import React from 'react';
import { Header } from '../components/Header';
import { HeroGallery } from '../components/HeroGallery';
import { PropertyDescription } from '../components/PropertyDescription';
import { LocationSection } from '../components/LocationSection';
import { HouseRules } from '../components/HouseRules';
import { CancellationPolicy } from '../components/CancellationPolicy';
import { AvailabilityCalendar } from '../components/AvailabilityCalendar';
import { SeasonalPricing } from '../components/SeasonalPricing';
import { ContactForm } from '../components/ContactForm';
import { WhatsAppWidget } from '../components/WhatsAppWidget';
import { Footer } from '../components/Footer';

export const PropertyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <HeroGallery />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <PropertyDescription />
            <LocationSection />
            <HouseRules />
            <CancellationPolicy />
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 border rounded-xl p-6 shadow-sm bg-white">
              <AvailabilityCalendar />
              <SeasonalPricing />
              <ContactForm />
              <div className="mt-4">
                <WhatsAppWidget />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
